module.exports = __webpack_public_path__ + "img/9788997367634.05bace93.jpg";